import { connectModal } from 'redux-modal';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { pipe } from 'ramda';

import { deleteCardioVascularReport } from 'store/actionCreators/reports/singleItems';
import { DELETE_CARDIO_VASCULAR_REPORT } from 'constants/modals';
import DeleteCardioVascularReport from './DeleteCardioVascularReport';

const mapDispatchToProps = (dispatch, { reportId, onPageChange }) => ({
  handleRemoveClick: () => dispatch(deleteCardioVascularReport({ reportId, onPageChange })),
});

export default pipe(
  connect(
    null,
    mapDispatchToProps,
  ),
  connectModal({ name: DELETE_CARDIO_VASCULAR_REPORT }),
  withTranslation(),
)(DeleteCardioVascularReport);
